import { PageHero, CtaBand } from "@/components/Blocks";
import { Comparison, Framework } from "@/components/Science";
import { TrustStrip, Marquee } from "@/components/Strips";
import { Faq } from "@/components/Stories";
import { IMG } from "@/data/content";

export default function Approach() {
  return (
    <main data-testid="approach-page">
      <PageHero
        testId="approach-hero"
        eyebrow="Our approach"
        lines={["From symptom", "management to", "Post-Traumatic Growth."]}
        intro="100% drug-free, root-cause recovery that eliminates emotional attachment to traumatic memories and delivers Post-Traumatic Growth."
        image={IMG.s1}
      />
      <TrustStrip />
      <Comparison />
      <Framework />
      <Marquee />
      <Faq />
      <CtaBand />
    </main>
  );
}
